import Axios from 'axios';
var SalePriceAnalyzeService = (function () {
    function SalePriceAnalyzeService() {
    }
    SalePriceAnalyzeService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/sale_report/price_analyze', { params: params });
    };
    SalePriceAnalyzeService.prototype.getDetail = function (params) {
        return Axios.get('supplierclientapi/sale_report/price_analyze_detail', { params: params });
    };
    SalePriceAnalyzeService.createInstance = function () {
        SalePriceAnalyzeService.getInstance();
    };
    SalePriceAnalyzeService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return SalePriceAnalyzeService;
}());
export default SalePriceAnalyzeService;
